import { useEffect, useState, useCallback } from "react"
import useAxios from "./useAxios"
import Constants from "../Constants"
import { getDashboardFilterQueryString } from "../utils/helper"
import { useCompanyFilterContext } from "../pages/superAdmin/components/context/CompanyFilterContext"

const useUpcomingCompany = () => {
    const { filterParams } = useCompanyFilterContext()
    const { selectedRange, selectedTiers, selectedStatus, selectedAccountExecutive, selectedCompanies } = filterParams
    const { getData } = useAxios()
    const [companiesData, setCompaniesData] = useState([])

    const fetchUpcomingCompany = useCallback(async () => {
        const url = Constants.ApiUrl.super.dashboard.upcomingCompany
        const query = getDashboardFilterQueryString({ selectedRange, selectedTiers, selectedStatus, selectedAccountExecutive, selectedCompanies })
        const { success, data } = await getData(`${url}?${query}`)
        if (success) {
            setCompaniesData(data)
        }
    }, [selectedRange, selectedTiers, selectedStatus, selectedAccountExecutive, selectedCompanies])

    useEffect(() => {
        fetchUpcomingCompany()
    }, [fetchUpcomingCompany])

    return { companiesData }
}

export default useUpcomingCompany
